<template>
  <div
    class="min-h-screen flex flex-col justify-between bg-cover bg-center"
    :style="`background-image: url(${reservedBg})`"
  >
    <div class="flex-1 flex flex-col items-center justify-center mt-20">
      <div
        class="bg-[#232323] rounded-none px-8 py-12 flex flex-col items-center w-full max-w-lg mx-4 relative"
        style="box-shadow: 0 4px 20px rgba(255, 255, 255, 0.2)"
      >
        <!-- Checkmark and Table Icon -->
        <div class="mb-6 flex flex-col items-center">
          <img
            src="@/assets/icons/tableReserved.svg"
            alt="Reserved Icon"
            class="w-28 h-28"
          />
        </div>
        <!-- Thank You Message -->
        <div class="text-center px-4">
          <!-- "Thank You!" -->
          <div
            style="font-family: 'Great Vibes', cursive"
            class="text-white italic mb-2 tracking-[0.3em] text-[18px] sm:text-[20px] md:text-[24px]"
          >
          {{ $t("reserved.thank_you") }}
          </div>

          <!-- "Your table has been reserved" -->
          <div
            style="font-family: 'DM Serif Display', serif"
            class="text-[#F3D382] mb-4 text-[28px] sm:text-[32px] md:text-[40px]"
          >
          {{ $t("reserved.reserved_title") }}
          </div>

          <!-- Description -->
          <div
            style="font-family: 'DM Sans', sans-serif"
            class="text-white mb-6 text-[16px] sm:text-[18px] md:text-[20px]"
          >
          {{ $t("reserved.reserved_description") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import reservedBg from "@/assets/Booking/reservedBg.png";
import { onMounted } from "vue";

onMounted(() => {
  // Clear all booking-related localStorage data for new reservation
  localStorage.removeItem('bookingName');
  localStorage.removeItem('bookingPhone');
  localStorage.removeItem('bookingGuests');
  localStorage.removeItem('bookingDate');
  localStorage.removeItem('reservationId');
  localStorage.removeItem('date');
  localStorage.removeItem('duration');
  localStorage.removeItem('selectedTable');
  localStorage.removeItem('selectedTableName');
  
  console.log('Booking data cleared from localStorage');
});
</script>
